import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ls from 'local-storage';

export const useMarketingData = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Интеграция с Clickadu
    const visitor_id = searchParams.get('visitor_id');
    if (visitor_id) {
      ls('visitor_id', visitor_id);
    }

    // Интеграция с Bemob
    const click_id = searchParams.get('click_id');
    if(click_id) {
      ls('click_id', click_id);
    }
  }, []);
};
